/***
 * 地点单行单选
 */

import React from 'react';
import { getData } from '@util';
import { TreeSelect } from 'antd';
import { API_GET_LOAD_MANAGEMENT_CATEGORY_TREE } from '@api';
class CategoryData extends React.PureComponent {
  state = {
    manCategoryData: [],
  };

  componentDidMount() {
    this.getAddCodeFunc();
  }

  // 获取地点
  getAddCodeFunc = () => {
    getData({
      api: API_GET_LOAD_MANAGEMENT_CATEGORY_TREE,
    }).then(res => {
      const data = this.getMenu(res.data);
      this.setState({
        manCategoryData: [...data],
      });
    });
  };

  getMenu = data => {
    const childrenBox = [];
    data.map(item => {
      const obj = {};
      obj.title = `${item.value}${item.label}`;
      obj.value = `${item.value}`;
      obj.key = item.value;
      obj.children = item.children;
      if (item && item.children !== null) {
        obj.children = this.getMenu(item.children);
      }
      childrenBox.push(obj);
    });
    return childrenBox;
  };

  render() {
    const { manCategoryData } = this.state;

    return (
      <TreeSelect
        placeholder="请选择"
        showCheckedStrategy={TreeSelect.SHOW_CHILD}
        treeData={manCategoryData}
        treeCheckable={true}
        allowClear={true}
        dropdownMatchSelectWidth={false}
        maxTagCount={20}
        multiple={true}
      />
    );
  }
}

export default CategoryData;
